import {
	type Context,
	createContext,
	type ForwardRefExoticComponent,
	type PropsWithoutRef,
	type ReactNode,
	type RefAttributes,
} from 'react';

import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';

export type ModalShellProps = ModalDialogProps & { children: ReactNode };

export type ModalShell = ForwardRefExoticComponent<
	PropsWithoutRef<ModalShellProps> & RefAttributes<HTMLElement>
>;

export const ModalShellContext: Context<ModalShell | null> = createContext<ModalShell | null>(null);
